import { PRODUCTS, TABLES } from "../../managers/TableManger";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";

export const SCOPE = {
	ALL: "ALL",
	EMPLOYEE: "EMPLOYEE",
};

export const MODULE_ACCESS = {
	HIRING: "HIRING",
	PAYROLL: "PAYROLL",
	COMPOFF: "COMPOFF",
	ELEAVE: "ELEAVE",
	EXPENSE: "EXPENSE",
	SHIFT_MANAGEMENT: "SHIFT_MANAGEMENT",
	TIMESHEET: "TIMESHEET",
	INVESTMENTS: "INVESTMENTS",
	PERFORMANCE: "PERFORMANCE",
	REPORT_LIST: "REPORT_LIST",
	AUTOMATION: "AUTOMATION",
	BIOMETRIC_ATTENDANCE_SETUP: "BIOMETRIC_ATTENDANCE_SETUP",
	COMPANY_SETTINGS: "COMPANY_SETTINGS",
	PAYSTUB: "PAYSTUB",
	SELF_ASSESSMENT: "SELF_ASSESSMENT",
};

export function isModuleRestricted(accessControlData, nav) {
	const isAdmin = TenantService.get(TENANT.IS_ADMIN);
	const isOwner = TenantService.get(TENANT.IS_OWNER);

	if (Array.isArray(accessControlData)) {
		const all = accessControlData.find((s) => {
			return s.id === SCOPE.ALL;
		});
		if (isAccessRestricted(nav, all)) {
			return true;
		}

		if (!isAdmin && !isOwner) {
			const employee = accessControlData.find((s) => {
				return s.id === SCOPE.EMPLOYEE;
			});
			if (isAccessRestricted(nav, employee)) {
				return true;
			}
		}
	}

	return false;
}

function isAccessRestricted(nav, scopeData) {
	if (nav && Array.isArray(scopeData?.modules)) {
		const navId = typeof nav === "object" ? nav.id : nav;
		const module = scopeData.modules.find((m) => {
			switch (navId) {
				case "SELF_ASSESSMENT":
					return m.id === "PERFORMANCE" || m.id === navId;
				case "PAYSTUB":
					return m.id === "PAYROLL" || m.id === navId;
				case "REPORT_LIST_NEW":
					return m.id === "REPORT_LIST";
				default:
					return m.id === navId;
			}
		});
		if (module?.selected) {
			return true;
		}
	}

	return false;
}

export function getRestrictedRoutes(data) {
	const restrictedRoutes = {
		[SCOPE.ALL]: [],
		[SCOPE.EMPLOYEE]: []
	};
	data.forEach((scope) => {
		if (Array.isArray(scope.modules)) {
			scope.modules.forEach((module) => {
				if (module.selected) {
					if (scope.id === SCOPE.ALL) {
						restrictedRoutes.ALL.push(...module.routes);
					} else {
						restrictedRoutes.EMPLOYEE.push(...module.routes);
					}
				}
			});
		}
	});

	return filterNonRestrictedRoutes(restrictedRoutes);
}

export function isShowDasboardCard(accessControlData, card) {
	switch (card.name) {
		case TABLES.CANDIDATE:
			return PermissionUtils.hasAccess(MODULE.CANDIDATE, [ACTION.VIEW]) && !isModuleRestricted(accessControlData, MODULE_ACCESS.HIRING);
		case TABLES.JOB_PIPELINE:
			return PermissionUtils.hasAccess(MODULE.JOB_PIPELINE, [ACTION.VIEW]) && !isModuleRestricted(accessControlData, MODULE_ACCESS.HIRING);
		case TABLES.JOB_FORMS:
			return PermissionUtils.hasAccess(MODULE.JOB_FORM, [ACTION.VIEW]) && !isModuleRestricted(accessControlData, MODULE_ACCESS.HIRING);
		case TABLES.PEOPLE_EXPENSE_PENDING_CLAIMS:
		case PRODUCTS.EXPENSE_TREND:
		case TABLES.PEOPLE_EXPENSE_APPROVED_CLAIMS:
		case TABLES.PEOPLE_EXPENSE_CLAIMS_BREAKDOWN_GROUP:
		case TABLES.PEOPLE_EXPENSE_CLAIMS_BREAKDOWN_CATEGORY:
		case TABLES.PEOPLE_EXPENSE_MY_CLAIMS:
			return PermissionUtils.hasAccess(MODULE.EXPENSE_CLAIM, [ACTION.VIEW]) && !isModuleRestricted(accessControlData, MODULE_ACCESS.EXPENSE);
		case TABLES.TEAM_ATTENDANCE:
			return PermissionUtils.hasAccess(MODULE.TEAM_ATTENDANCE, [ACTION.VIEW]) && !isModuleRestricted(accessControlData, MODULE_ACCESS.ELEAVE);
		default:
			return false;
	}
}

const EMPLOYEE_ROUTES = ["/employee-details/"];

function filterNonRestrictedRoutes(routes) {
	const isAdmin = TenantService.get(TENANT.IS_ADMIN);
	const isOwner = TenantService.get(TENANT.IS_OWNER);

	if (isAdmin || isOwner) {
		return [...routes.ALL];
	} else {
		return [...routes.ALL, ...routes.EMPLOYEE].filter(r => !EMPLOYEE_ROUTES.includes(r));
	}
}
